import clsx from 'clsx';
import { useToggle } from 'react-use';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import AddLink from '~components/generic/elements/add-link/AddLink';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { IEntityComponentProps } from '~interfaces/props';
import { convertToRawValue } from '~services/data-conversion';
import { getFieldValue, getRelatedEntityIds } from '~services/entity-helpers';
import stripHtml from '~utils/stripHtml';

export default function ModuleExploreBrands(props: IEntityComponentProps) {
  const [isActive, toggleIsActive] = useToggle(false);

  const { data, editing, className, onChange, onAddNewChild, origData } = props;
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const classes = clsx({
    ...className,
    'u-padding-vertical-xl': true,
  });
  const liClasses = clsx({
    'u-margin-top-md': true,
    'u-padding-vertical-lg': true,
    'c-accordion__item': true,
    relative: true,
  });
  const childModuleIds = getRelatedEntityIds(data, 'field_items');
  const childModuleIdsLength = childModuleIds.length - 1;
  const isActiveOrEditing = isActive || props.editing;

  const fieldTitle = content.field_title ? stripHtml(convertToRawValue(content.field_title.value)) : '';
  return (
    <div className={classes} id={data.id}>
      <div className="o-container o-container--lg relative c-explore-brands">
        <ul className="c-accordion u-margin-vertical-md js-accordion c-module__content">
          <li className={liClasses}>
            {editing ? (
              <span className="c-accordion__item-title u-nowrap">
                <EditableField
                  entityType={data.type}
                  fieldName="attributes.field_title.value"
                  data={fieldTitle}
                  editing={editing}
                  onChange={onChange}
                />
                <i className="c-accordion__item-title-icon u-absolute u-absolute--top u-absolute--right" />
              </span>
            ) : (
              <a onClick={toggleIsActive} className="c-accordion__item-title" aria-expanded={isActiveOrEditing}>
                <h3>{fieldTitle}</h3>
                <i className="c-accordion__item-title-icon u-absolute u-absolute--right" />
              </a>
            )}
            <div aria-hidden={!isActiveOrEditing} className="c-accordion__item-content c-module__content">
              <div className="u-explore-brands-list">
                {childModuleIds.map((id, i) => {
                  return (
                    <div key={i}>
                      <DraggableModuleContainer
                        index={i}
                        key={id}
                        entityId={id}
                        parentContext={getFieldValue<string>(data, 'attributes.parent_id')}
                        parentType={getFieldValue<string>(data, 'attributes.parent_type')}
                        fieldName="relationships.field_items.data"
                        siblingsLength={childModuleIdsLength}
                        canMove={editing}
                      />
                    </div>
                  );
                })}
                {editing && (
                  <AddLink
                    onClick={() =>
                      onAddNewChild({
                        id: origData,
                        fieldName: 'relationships.field_items.data',
                        templateType: 'paragraph--explore_brands_item',
                      })
                    }
                  />
                )}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
